export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholderError.png";